import React from "react";
import { useTranslation } from "react-i18next";

import CustomTabs from "../components/Shared/CustomTabs";
import GalleryInvoicesMain from "./GalleryInvoicesMain";
import RevokeGalleryInvoices from "./RevokeGalleryInvoices";
import CreditNotes from "../thirdParty/CreditNotes";
import InsuranceClaimRevokeInvoices from "../Pages/insuranceClaimInvoice/InsuranceClaimRevokeInvoices";
function ThirdPartyTable({ activeTab, childIndex }) {
  const { t } = useTranslation();

  const galleryTabs = (t) => {
    return [
      {
        name: t("invoices"),
        content: <GalleryInvoicesMain activeTab={activeTab} />,
      },
      // {
      //   name: t('revoke_invoices'),
      //   content: <RevokeGalleryInvoices activeTab={activeTab} />
      // },
      {
        name: t("Credit Notes"),
        content: <RevokeGalleryInvoices activeTab={activeTab} />,
      },
    ];
  };

  return (
    <div>
      <CustomTabs tabs={galleryTabs(t)} activeTabIndex={childIndex || 0} />
    </div>
  );
}

export default ThirdPartyTable;
